import { render, staticRenderFns } from "./_ReferenceDialog.vue?vue&type=template&id=8d3c7cfc&scoped=true&"
import script from "./_ReferenceDialog.vue?vue&type=script&lang=js&"
export * from "./_ReferenceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3c7cfc",
  null
  
)

export default component.exports